import { type TFunction } from "i18next"
import React from "react"

import Icon from "../../../Icon"
import type { NearbyBreakdownCounts } from "./useNearbyFeatures.ts"

interface BreakdownRowSpec {
  key: keyof NearbyBreakdownCounts
  icon: React.ReactNode
  color: string
  label: string
}

// Same icons/colors/labels the page's own top KPI row uses for these same
// four entities (`GlobalMapHeader.tsx`) — reusing rather than inventing a
// second palette. Workforce is deliberately not a row here (or anywhere in
// Global Map) — no data model for it exists in this backend at all. Shared
// by the always-visible `NearbyBreakdownSummary` and the dedicated Nearby
// tab (`QuickViewNearby`) so the two never drift apart.
function nearbyBreakdownRows(t: TFunction): BreakdownRowSpec[] {
  return [
    {
      key: "project",
      icon: <Icon type="Home" />,
      color: "#16a34a",
      label: t("globalMap.list.projects")
    },
    {
      key: "lead",
      icon: <Icon type="Map" />,
      color: "#1677ff",
      label: t("globalMap.list.leads")
    },
    {
      key: "subcontractor",
      icon: <Icon type="Projects" />,
      color: "#9333ea",
      label: t("globalMap.list.subcontractors")
    },
    {
      key: "appointment",
      icon: <Icon type="Calendar" />,
      color: "#0ea5e9",
      label: t("globalMap.list.appointments")
    }
  ]
}

export { nearbyBreakdownRows }
export type { BreakdownRowSpec }
